var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.64365 4.46254L8.88115 3.22504C9.4051 2.74749 10.0929 2.49019 10.8016 2.5066C11.5104 2.52301 12.1855 2.81186 12.6868 3.31315C13.1881 3.81443 13.4769 4.48959 13.4933 5.19832C13.5098 5.90705 13.2524 6.59485 12.7749 7.11879L11.0062 8.88129C10.7512 9.13716 10.4483 9.34018 10.1148 9.47871C9.7812 9.61724 9.42358 9.68855 9.0624 9.68855C8.70122 9.68855 8.3436 9.61724 8.01004 9.47871C7.67649 9.34018 7.37357 9.13716 7.11865 8.88129",
    stroke: "#525659",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.35629 11.5375L7.11879 12.775C6.59485 13.2526 5.90705 13.5099 5.19832 13.4935C4.48959 13.4771 3.81443 13.1882 3.31315 12.6869C2.81186 12.1856 2.52301 11.5105 2.5066 10.8018C2.49019 10.093 2.74749 9.40523 3.22504 8.88128L4.99379 7.11878C5.24871 6.86291 5.55163 6.65989 5.88518 6.52136C6.21874 6.38283 6.57636 6.31152 6.93754 6.31152C7.29872 6.31152 7.65634 6.38283 7.9899 6.52136C8.32346 6.65989 8.62638 6.86291 8.88129 7.11878",
    stroke: "#525659",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon);
export default __webpack_public_path__ + "static/media/linkIcon.cc5a416f396bdc039e63f4ec892230a1.svg";
export { ForwardRef as ReactComponent };